// El mapa puede abrirse centrado en un lugar de interés y con su hoja abierta, `/?lugar=<id>`
// (desde "Ver en el mapa" de la ficha del lugar), en un lugar mágico, `/?lugar-magico=<id>`
// (desde el panel), o con una etapa elegida, `/?etapa=<id>` (desde la ficha de la etapa o al
// elegirla en el propio mapa).
const PLACE = 'lugar'
const MAGIC_PLACE = 'lugar-magico'
const STAGE = 'etapa'

const hrefWith = (param: string, id: string) => `/?${new URLSearchParams({ [param]: id })}`
const fromSearch = (param: string, search: string): string | null => {
	const id = new URLSearchParams(search).get(param)?.trim()
	return id ? id : null
}

export const mapHrefForPlace = (id: string) => hrefWith(PLACE, id)
export const placeFromSearch = (search: string) => fromSearch(PLACE, search)

export const mapHrefForStage = (id: string) => hrefWith(STAGE, id)
export const stageFromSearch = (search: string) => fromSearch(STAGE, search)

export const mapHrefForMagicPlace = (id: string) => hrefWith(MAGIC_PLACE, id)
export const magicPlaceFromSearch = (search: string) => fromSearch(MAGIC_PLACE, search)
